import { PageType } from "../pages/base";

export enum InputVariant {
    DEFAULT = "default",
    FILLED = "filled",
}

export enum FormVariant {
    DEFAULT = "default",
    FULLWIDTH = "fullWidth",
}

export interface VariantConfig {
    input: InputVariant;
    form: {
        variant: FormVariant;
        font?: string;
    };
}

export const getVariantConfig = (pageType?: PageType | null): VariantConfig => {
    // Removed debug log to avoid unintended console output in production

    if (pageType === PageType.COMPETITION) {
        return {
            input: InputVariant.FILLED,
            form: {
                variant: FormVariant.FULLWIDTH,
                font: "var(--font-roboto-flex),sans-serif",
            },
        };
    } else {
        return {
            input: InputVariant.DEFAULT,
            form: { variant: FormVariant.DEFAULT },
        };
    }
};
